import { icons } from 'smartsuite-ui';
import { printOrientation } from '../../shared/constants/constants';

const dashboardExportTypes = [
    {
        id: 'pdf',
        orientation: printOrientation.portrait,
        extension: '.pdf',
        headers: {
            accept: 'application/pdf',
        },
        icon: icons.print,
    },
    {
        id: 'pdf',
        orientation: printOrientation.landscape,
        extension: '.pdf',
        headers: {
            accept: 'application/pdf',
        },
        icon: icons.print,
    },
];

export default dashboardExportTypes;
